module.exports = __webpack_public_path__ + "src/assets/img/okkostudiodistrib.c4c096cd.jpg";